// react
import React from "react"
import { connect } from "react-redux"
// material-ui
import Dialog from "material-ui/Dialog"
import FlatButton from "material-ui/FlatButton"
// dropzone
import Dropzone from "react-dropzone"
// app
import Files from "components/person/Files"
import SelectField from "containers/SelectField"

import { getFiles, postFile, deleteFile } from "actions/profile/files/actions.js"


const initialState = {
    open: false,
    formData: {},
    filetype: 0
}

class Step6 extends React.Component {
    constructor(props) {
        super()

        this.state = initialState

        this.ok = () => this.setState(initialState)
        this.cancel = () => this.setState(initialState)

        this.onFileDelete = id => this.props.deleteFile(id)
        this.handleFiletypeChange = (filetype) => this.setState({ filetype })

        this.onDrop = this.onDrop.bind(this)
        this.upload = this.upload.bind(this)
    }

    componentDidMount() {
        const personid = this.props.personid

        this.props.getFiles(personid)
    }

    upload() {
        const { formData } = this.state
        formData.append("filetype", this.state.filetype)
        this.props.postFile(formData)
        this.setState(initialState)
    }

    onDrop(files) {
        if (files.length !== 1) return

        const formData = new FormData()
        formData.append("file", files[0])
        formData.append("personid", this.props.personid)

        this.setState({
            open: true,
            formData
        })
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-xs-12">
                        <Dialog
                            title="Please provide a few more details:"
                            actions={ [
                                <FlatButton
                                    label="Upload"
                                    primary={ true }
                                    onTouchTap={ this.upload }
                                    disabled={ this.state.filetype === 0 }
                                />,
                                <FlatButton
                                    label="Cancel"
                                    secondary={ true }
                                    onTouchTap={ this.cancel }
                                />
                            ] }
                            modal={ true }
                            open={ this.state.open }
                        >
                            <SelectField
                                table="filetype"
                                value={ this.state.filetype }
                                label="File Type"
                                mandatory={ true }
                                onChange={ this.handleFiletypeChange }
                            />
                        </Dialog>
                        <Dropzone
                            onDrop={ this.onDrop }
                            multiple={ false }
                            style={{
                                backgroundColor: "#fff",
                                border: "2px dashed #ccc",
                                height: "200px",
                                width: "100%"
                            }}
                        >
                            <div style={{
                                height: "100%",
                                lineHeight: "200px",
                                textAlign: "center"
                            }}>Simply drop your files here, or click to select files to upload (max. 5 MB)</div>
                        </Dropzone>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <Files
                            data={ this.props.files }
                            onDelete={ this.onFileDelete }
                        />
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        files: state.profile.files.get("data")
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getFiles: personid => dispatch(getFiles(personid)),
        postFile: formData => dispatch(postFile(formData)),
        deleteFile: id => dispatch(deleteFile(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Step6)



/** WEBPACK FOOTER **
 ** ./src/containers/Profile/Step6.js
 **/